import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'channelMap';

export class ChannelMap extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
